// Default staff-fe cap on a trailer's insured value.
export const DEFAULT_MAX_TRAILER_VALUE = 50000;

/**
 * The trailer-value cap for a policy modification: max($50k, the value already on the policy record).
 *
 * New business and newly-added trailers stay hard-capped at $50k, but the migrated CFM book carries
 * trailers valued above $50k, and a fixed cap blocked staff from saving ANY edit to those policies
 * (#35121). Keying the cap off the trailer's persisted value (matched by VIN against the form's
 * initialValues) grandfathers those trailers — the value can be kept or lowered, just not raised
 * beyond what was already on the policy.
 *
 * @param {Array<{VIN?: string, value?: number|string}>} originalTrailers the persisted trailers
 *   (from the form's initialValues), i.e. the values on the policy record before this edit.
 * @param {string} [vin] the VIN of the trailer being validated.
 */
export const getTrailerValueCap = (originalTrailers, vin) => {
  const original = vin && Array.isArray(originalTrailers) ? originalTrailers.find((t) => t?.VIN === vin) : undefined;
  const originalValue = Number(original?.value);
  return Math.max(DEFAULT_MAX_TRAILER_VALUE, Number.isFinite(originalValue) ? originalValue : 0);
};
